module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/28a2a4b4f4ed9c82303efbc0945efa4a.gif";